module.exports = __webpack_public_path__ + "static/media/telegram.7bbc8f52.svg";